// REACT
import React from 'react';

// AXIOS
import axios from 'axios';

// STYLES
import styled from "styled-components";

// COMPONENTS
import Loading from '../../components/loading/loading.component';

// SHARED
import Settings from '../../shared/settings';

// CONTAINERS
import GoogleMaps from '../../containers/GoogleMaps/googleMaps.container';


export default class Maps extends React.Component {
    state = {
        status: 0,
        res: JSON.parse(localStorage.getItem('mapData')),
    }

    componentWillMount() {
        if (this.state.res.length === 0){
            this.loadData();
        } else {
            this.setState({
                status: 1
            })
        }
    }

    loadData() {
        const {
            go,
            i18n
        } = this.props;

        const url = Settings.server+'/api/v1/'+go+'?fields=id,coordinates,country,slug,name,network&per-page=0&lang='+i18n.language+'&sort=network'
        axios.get(url)
            .then(
                res => {
                    localStorage.setItem('mapData', JSON.stringify(res.data))
                    this.setState({
                        status: 1,
                        res: res.data,
                        isLoading: false
                    })
                }
            )
            .catch(
                err => {
                    this.setState({
                        status: 2
                    })
                }
            )
    }

    render() {
        const {
            status,
            res,
        } = this.state;

        const {
            t,
            to,
            i18n
        } = this.props;

        return(
            <MapsContent>
                {
                    status === 0 &&
                        <LoadingPage>
                            <Loading/>
                        </LoadingPage>
                }
                {
                    status === 1 && 
                       <GoogleMaps
                            data={res}
                            to={to}
                            i18n={i18n}
                    />
                }
                {
                    status === 2 && 
                        <ErrorPage>
                            {t('Ocorreu um erro. Tente novamente')}
                        </ErrorPage>
                }
            </MapsContent>
        )
    }
}

const MapsContent = styled.div `
    width: 100%;
    height: 600px;
    margin-top: -59px;
    position: relative;
`
const LoadingPage = styled.div `
    margin-top: 120px;
    height: 300px;
`
const ErrorPage = styled.div `
    text-align: center;
    width: 100%;
    height: 300px;
    color: #666666;
    margin-top: 120px;
`


// WEBPACK FOOTER //
// ./src/containers/Maps/Maps.container.js